import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex w-100 justify-content-end page-heading-toolbar" }
const _hoisted_3 = { class: "page-heading-toolbar--col" }
const _hoisted_4 = { class: "bundles-wrapper" }
const _hoisted_5 = { class: "table-tabs-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Delete this bundle?")
  ])
], -1)

import { computed, ComputedRef, onBeforeMount, Ref, ref, watch } from "vue";
import PageMainHeading from "@/components/Layout/PageMainHeading.vue";
import AppButton from "@/components/ui/Buttons/AppButton.vue";
import AppTableController from "../../../components/Table/ts/AppTableController.vue";
import AppTable from "@/components/Table/ts/AppTable.vue";
import DeleteConfirmDialog from "@/components/ui/Modal/Dialog/instances/DeleteConfirmDialog.vue";
import UpdateBundleModal from "@/components/Packages/eSIM/UpdateBundleModal.vue";
import HeadToolBar from "@/components/Table/HeadToolBar.vue";

import BtnContent from "../../../components/ui/Buttons/BtnContent.vue";
import DragAndDrop from "@/components/ui/DragAndDrop.vue";
import Dialog from "@/components/ui/Modal/Dialog/Dialog.vue";
import {
  ITableBodyRow,
  ITableHeadCell
} from "@/components/Table/ts/interfaces/TableStructure";

import { api } from "@/api/Api";
import { useStore } from "vuex";
import { useBaseTable } from "@/hooks/tables/useTable";
import {
  IBundle,
  IBundlesProviders,
IEsimGoBundle
} from "@/api/services/packages/esim/location-packages/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'ESIMBundles',
  setup(__props) {

const store = useStore();

const initialViewConfiguration = { page: 1, perPage: 10 };
const uploadLoading = ref(false);
const loading = ref(false);
const importModalOpened = ref(false);
const deleteModal = ref(false);
const editModal = ref(false);

const uploadProgress = ref(0);
const uploadSuccess: Ref<boolean | null> = ref(null);
const uploadErrorMessage = ref("");

const bundles: Ref<IBundle[] | IEsimGoBundle[]> = ref([]);
const totalBundles = ref(0);
const currentBundle = ref({} as IBundle);

function hideImportModal() {
  if (uploadLoading.value) return;

  importModalOpened.value = false;
  uploadProgress.value = 0;
  uploadLoading.value = false;
  uploadErrorMessage.value = "";
  uploadSuccess.value = null;
}

const toggleDeleteModal = (value: boolean) => {
  deleteModal.value = value;

  if (!value) {
    currentBundle.value = {} as IBundle;
  }
};

const toggleEditModal = (value: boolean) => {
  editModal.value = value;

  if (!value) {
    currentBundle.value = {} as IBundle;
  }
};

async function changeTabHandler(idx: number) {
  selectedTab.value = providers.value[idx];
  if (
    tableRefs.viewConfiguration.page !== initialViewConfiguration.page ||
    tableRefs.viewConfiguration.perPage !== initialViewConfiguration.perPage
  ) {
    tableRefs.changeViewConfiguration(initialViewConfiguration);
  } else {
    await fetchBundles();
  }
}

const providers: Ref<IBundlesProviders[]> = ref([]);
const providersTitles = computed(() => {
  return providers.value.map(({ name }) => name);
});
const selectedTab: Ref<IBundlesProviders> = ref({ ...providers.value[0] });
const isEsimGoProvider = computed(() => selectedTab.value?.name === "EsimGo");

const rows = computed(() => tableRefs.rows.value);
const cells: ComputedRef<ITableHeadCell[]> = computed(() => {
  if (!isEsimGoProvider.value) {
    return [
      {
        id: "i_product",
        label: "I Product",
        size: "md"
      },
      {
        id: "name",
        label: "Name",
        size: "xxl"
      }
    ];
  } else {
    return [
      {
        id: "name",
        label: "Name",
        size: "xxl"
      },
      {
        id: "description",
        label: "Description",
        size: "xxl"
      },
      {
        id: "price",
        label: "Price",
        size: "md"
      }
    ];
  }
});

const tableRefs = useBaseTable({
  initialViewConfiguration: { page: 1, perPage: 10 },
  model: computed(() => bundles.value),
  initialSortOptions: {},
  generateRows(bundlesList: IBundle[] | IEsimGoBundle[] = []): ITableBodyRow[] {
    if (!bundlesList) {
      return [];
    }
    return bundlesList.map(
      (bundle): ITableBodyRow => {
        if ("i_product" in bundle) {
          const { i_product, name } = bundle;

          return {
            onClick: () => {},
            actions: [
              {
                text: "Edit",
                onClick: () => {
                  currentBundle.value = bundle;
                  toggleEditModal(true);
                }
              },
              {
                text: "Delete",
                onClick: () => {
                  currentBundle.value = bundle;
                  toggleDeleteModal(true);
                }
              }
            ],
            cells: [
              {
                label: i_product.toString()
              },
              {
                label: name
              }
            ]
          };
        } else {
          const { name, description, price } = bundle;

          return {
            onClick: () => {},
            cells: [
              {
                label: name
              },
              {
                label: description
              },
              {
                label: price.toString()
              }
            ]
          };
        }
      }
    );
  },
  onViewConfigurationChanged: () => {
    fetchBundles();
  }
});

async function importFile(table: File) {
  uploadProgress.value = 0;
  uploadSuccess.value = null;
  uploadErrorMessage.value = "";

  uploadLoading.value = true;

  const { data } = await api.importBundle(table, (progress: number) => {
    if (uploadProgress.value === 0) {
      if (progress === 100) {
        const interval = setInterval(() => {
          uploadProgress.value += 0.6;
          if (uploadProgress.value >= 90) {
            clearInterval(interval);
          }
        }, 15);

        return;
      }

      uploadProgress.value = progress;
      return;
    }

    progress < 99 && (uploadProgress.value = progress);
  });

  uploadLoading.value = false;
  uploadProgress.value = 100;

  const isData = typeof data === "string";
  if (isData) {
    const msg = (data as unknown) as string;
    uploadErrorMessage.value = msg || "";
    uploadSuccess.value = false;
    return;
  }

  uploadSuccess.value = true;
  await fetchBundles();
}

async function fetchBundles() {
  const id = selectedTab.value.id;
  const view = tableRefs.viewConfiguration || initialViewConfiguration;

  if (id) {
    await store.dispatch("setAppLoading", true);
    const {
      success,
      message,
      data: bundlesList
    } = await api.fetchBundlesByProviderId({
      id,
      ...view
    });

    if (!success && message) {
      return await store.dispatch("showErrorNotification", message);
    }

    await store.dispatch("setAppLoading", false);
    bundles.value = bundlesList.result as IBundle[] | IEsimGoBundle[];
    totalBundles.value = (bundlesList.total as number) ?? 0;
    return;
  }
}

async function fetchAllBundles() {
  await store.dispatch("setAppLoading", true);

  const { success, message, data: providersList } = await api.fetchAllBundles();

  if (!success && message) {
    return await store.dispatch("showErrorNotification", message);
  }

  await store.dispatch("setAppLoading", false);
  providers.value = (providersList ?? []).reverse() as IBundlesProviders[];
  selectedTab.value = providers.value[0];
  await fetchBundles();
}

const buttonLoading = ref(false);
async function synchronizeEsimGoBundles() {
  buttonLoading.value = true;
  const { success, message } = await api.synchronizeEsimGoBundles();
  if (!success && message) {
    buttonLoading.value = false;
    return await store.dispatch("showErrorNotification", message);
  }
  if (success) {
    await store.dispatch("setAppLoading", true);
    await fetchBundles();
  }
  buttonLoading.value = false;
  await store.dispatch("setAppLoading", false);
}

watch(
  () => importModalOpened.value,
  opened => {
    if (!opened) {
      uploadProgress.value = 0;
    }
  }
);

watch(
  () => importModalOpened.value,
  opened => {
    if (!opened) {
      uploadProgress.value = 0;
    }
  }
);

watch(
  () => loading.value,
  isLoading => {
    if (!isLoading) {
      fetchBundles();
    }
  }
);

onBeforeMount(() => {
  fetchAllBundles();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Dialog, {
      title: "Bundles upload",
      opened: importModalOpened.value,
      "can-close": !uploadLoading.value,
      onHide: hideImportModal
    }, {
      default: _withCtx(() => [
        _createVNode(DragAndDrop, {
          accepted: ['XLS', 'XLSX'],
          loading: uploadLoading.value,
          progress: uploadProgress.value,
          "upload-success": uploadSuccess.value,
          "upload-error": uploadErrorMessage.value,
          onFileChanged: importFile
        }, null, 8, ["loading", "progress", "upload-success", "upload-error"])
      ]),
      _: 1
    }, 8, ["opened", "can-close"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PageMainHeading, { title: "Bundles" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!_unref(isEsimGoProvider))
                ? (_openBlock(), _createBlock(AppButton, {
                    key: 0,
                    size: "xl",
                    type: "secondary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (importModalOpened.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(BtnContent, {
                        icon: "plus",
                        label: "Import File"
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(AppButton, {
                    key: 1,
                    size: "xl",
                    type: "secondary",
                    loading: buttonLoading.value,
                    onClick: synchronizeEsimGoBundles
                  }, {
                    default: _withCtx(() => [
                      _createVNode(BtnContent, { label: "Synchronize" })
                    ]),
                    _: 1
                  }, 8, ["loading"]))
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(HeadToolBar, {
            tabs: _unref(providersTitles),
            "initial-selected-tab": 0,
            "parent-selected-tab-id": selectedTab.value.id,
            onChangeTab: changeTabHandler
          }, null, 8, ["tabs", "parent-selected-tab-id"]),
          _createVNode(AppTableController, {
            "show-table": true,
            "empty-key": "bundles",
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createVNode(AppTable, {
                "table-head": _unref(cells),
                "table-body": _unref(rows),
                "total-rows": totalBundles.value,
                "current-page": _unref(tableRefs).viewConfiguration.page,
                "per-page": _unref(tableRefs).viewConfiguration.perPage,
                "pagination-capture-key": "Bundles",
                onChangeViewConfiguration: _unref(tableRefs).changeViewConfiguration,
                onSort: _unref(tableRefs).changeSorting
              }, null, 8, ["table-head", "table-body", "total-rows", "current-page", "per-page", "onChangeViewConfiguration", "onSort"])
            ]),
            _: 1
          })
        ]),
        _createVNode(DeleteConfirmDialog, {
          opened: deleteModal.value,
          loading: loading.value,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (toggleDeleteModal(false))),
          onConfirm: _ctx.deleteBundle,
          onHide: _cache[2] || (_cache[2] = ($event: any) => (toggleDeleteModal(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["opened", "loading", "onConfirm"]),
        _createVNode(UpdateBundleModal, {
          "edit-data": { name: currentBundle.value.name },
          opened: editModal.value,
          loading: loading.value,
          onHide: _cache[3] || (_cache[3] = ($event: any) => (toggleEditModal(false))),
          onSubmit: _ctx.editBundle
        }, null, 8, ["edit-data", "opened", "loading", "onSubmit"])
      ])
    ])
  ], 64))
}
}

})